import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  GET_SUB_CATEGORY_HELP_FAQ,
  GET_VENDOR_HELP_FAQ,
} from "../../types";
import { setErrors } from "../errorActions";

export const superadmin_add_faq =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const add_faq = await axios.post(
        `${serverApi}/admin/help-and-faq`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (add_faq.status === 201) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_get_all_faq_by_catid =
  (
    categoryId,
    token
    // onSuccess
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const get_faq_by_catId = await axios.get(
        `${serverApi}/admin/help-and-faq?category_id=${categoryId}`,
        {
          headers: { Authorization: token },
        }
      );
      if (get_faq_by_catId.status === 200) {
        dispatch({
          type: GET_SUB_CATEGORY_HELP_FAQ,
          payload: get_faq_by_catId.data,
        });
        // onSuccess(get_faq_by_catId.data);

        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_update_faq_by_id =
  (dataId, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const update_faq_by_catId = await axios.patch(
        `${serverApi}/admin/help-and-faq/${dataId}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (update_faq_by_catId.status === 200) {
        if (onSuccess) onSuccess(update_faq_by_catId.data);
        // dispatch({ type: CLEAR_LOADER });
        dispatch(superadmin_get_all_faq_by_catid(formData?.category_id, token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_update_all_faq_by_catid =
  (dataId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const update_faq_by_catId = await axios.patch(
        `${serverApi}/admin/help-and-faq/:${dataId}`,
        {
          headers: { Authorization: token },
        }
      );
      if (update_faq_by_catId.status === 200) {
        onSuccess(update_faq_by_catId.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_help_faq =
  (dataId, token, categoryID, onSuccessDelete) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const update_faq_by_catId = await axios.delete(
        `${serverApi}/admin/help-and-faq/${dataId}`,
        {
          headers: { Authorization: token },
        }
      );
      if (update_faq_by_catId.status === 200) {
        dispatch(superadmin_get_all_faq_by_catid(categoryID, token));
        onSuccessDelete();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_get_all_help_faq = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  try {
    const get_all_vendor_faq = await axios.get(
      `${serverApi}/vendor/help-and-faq`
    );
    if (get_all_vendor_faq.status === 200) {
      dispatch({
        type: GET_VENDOR_HELP_FAQ,
        payload: get_all_vendor_faq.data,
      });
      // onSuccess(get_all_vendor_faq.data);
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
